
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NavigationButton.css';
import Link from '../Link';
import Icon from '../Icon';
import Badge from '../Badge';
import { getNumberToBadge } from '../../core/navigationHelper';

class NavigationButton extends React.Component {
  render() {
    const iconSize = 41;
    const { link, message, iconName, alertsCount, profileNumber } = this.props;
    if (link === '/logout') {
      return (
        <div className={s.button}>
          <a className={s.link} href="/logout">
            <Icon iconName={iconName} className="Icon--block" size={iconSize} />
            <span className={s.below}>
              <FormattedMessage {...message} />
            </span>
          </a>
        </div>
      );
    } else if (link === '/messages' || link === '/notifications' || link.startsWith('/profile')) {
      const numberToBadge = getNumberToBadge(link, alertsCount, profileNumber);
      return (
        <div className={s.button}>
          <Link className={s.link} to={link}>
            <Icon iconName={iconName} className="Icon--block" size={iconSize}>
              <Badge number={numberToBadge} />
            </Icon>
            <span className={s.below}>
              <FormattedMessage {...message} />
            </span>
          </Link>
        </div>
      );
    }
    return (
      <div className={s.button}>
        <Link className={s.link} to={link}>
          <Icon iconName={iconName} className="Icon--block" size={iconSize} />
          <span className={s.below}>
            <FormattedMessage {...message} />
          </span>
        </Link>
      </div>
    );
  }
}

NavigationButton.propTypes = {
  message: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  link: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  alertsCount: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  profileNumber: PropTypes.number.isRequired,
};

export default withStyles(s)(NavigationButton);


// WEBPACK FOOTER //
// ./src/components/NavigationButton/NavigationButton.js